import Ad from "@components/Advertisement/Ad";
import AdSettings from "@components/Advertisement/AdSettings";
import Container from "@components/Container/Container";
import GAData from "@components/GAData/GAData";
import MetaTags from "@components/MetaTags/MetaTags";
import EventsAwardsHeader from "@events-awards/EventAwardsHeader";
import EventsAwardsNavigationBar from "@events-awards/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import {
  EVENTS_AWARDS_SBA_LABEL,
  EVENTS_AWARDS_SBA_PATH,
} from "@events-awards/utils/constants";
import {
  getStaticPageTitle,
  SBAStaticPageFactory,
} from "@events-awards/utils/helpers";
import { AwardType } from "@events-awards/utils/types";
import SBAFooter from "@sba/components/SBAFooterComponents/SBAFooter";
import { useDetectAdBlock } from "adblock-detect-react";

type SBAStaticPageProps = {
  /** The url string to get url at SBA static page. */
  urlPath: string;
};

/**
 * Component to render SBA static navigation pages
 */
const SBAStaticPage = ({ urlPath }: SBAStaticPageProps): React.ReactElement => {
  const adBlockDetected = useDetectAdBlock();

  const StaticLayout = SBAStaticPageFactory(urlPath);

  return (
    <div className="w-full" data-testid="sba-static-page-component">
      <AdSettings
        adNames={["lb1", "prestitial", "catfish", "abm"]}
        path={EVENTS_AWARDS_SBA_PATH}
        adTargets={[{ key: "page", value: "listing" }]}
      />

      <GAData
        title="Singapore Business Awards"
        level2="events awards"
        adblocker={adBlockDetected ? 1 : 0}
      />

      <MetaTags
        title={getStaticPageTitle(urlPath) + "  - THE BUSINESS TIMES"}
        description={`THE BUSINESS TIMES ${EVENTS_AWARDS_SBA_LABEL} - Find ${EVENTS_AWARDS_SBA_LABEL} News & Headlines, insight and analysis in Singapore, ASBA-Pacific & global markets news at The Business Times.`}
        ogType="website"
        slug={EVENTS_AWARDS_SBA_PATH}
      />

      <EventsAwardsHeader />

      <Container rootClassName="pb-8 w-full justify-center px-3 text-left text-gray-850">
        <EventsAwardsNavigationBar awardType={AwardType.SBA} />

        <>{StaticLayout ? <StaticLayout /> : null}</>
      </Container>

      <SBAFooter />

      <Ad adType="catfish" />

      <Ad adType="abm" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default SBAStaticPage;
